// extracted by mini-css-extract-plugin
module.exports = {"optionName":"SaasBundleOptions_optionName__12fBh"};